
import styled from 'styled-components';
import { SectionWithCtaIconCardProps } from './query';
import Button_v2 from '@/components/molecules/Button/index';
import CtaIconCard from '@/components/molecules/CtaIconCard';
import Paragraph from '@/components/molecules/Paragraph';
import Title_v2 from '@/components/molecules/Title/index';
import { renderUnderline } from '@/utilities/functions';

const CtaIconCardsContainer = styled.div`
	display: flex;
	flex-wrap: wrap;
	gap: 2.5rem;
	justify-content: center;
`;

const SectionWithCtaIconCard = ({ sectionWithCtaIconCardData }: { sectionWithCtaIconCardData: SectionWithCtaIconCardProps }) => {

	return (
		<>
			{sectionWithCtaIconCardData.title && (
				<Title_v2
					align={sectionWithCtaIconCardData.title.alignedAt}
					underlineColor={sectionWithCtaIconCardData.title.underlineColor}
				>
					{renderUnderline(sectionWithCtaIconCardData.title.titlePieces)}
				</Title_v2>
			)}
			{sectionWithCtaIconCardData.paragraphs && sectionWithCtaIconCardData.paragraphs.map(
				(paragraph, index) => <Paragraph paragraph={paragraph} key={index} />,
			)}
			<CtaIconCardsContainer>
				{sectionWithCtaIconCardData.cards.map(
					(card, index) => <CtaIconCard card={card} key={index} />,
				)}
			</CtaIconCardsContainer>
			{sectionWithCtaIconCardData.buttons && (
				sectionWithCtaIconCardData.buttons.map(
					(button, index) => (
						<Button_v2
							gtm_id={button.trackerId}
							href={button.url}
							key={index}
							openOnNewTab={button.newTab}
							text={button.text}
							version={button.variant}
						/>
					),
				)
			)}
		</>
	);
};

export default SectionWithCtaIconCard;
